import Vue from 'vue'
import VueRouter from 'vue-router'

import Isupplier from '../views/Isupplier.vue'
import Home from '../views/Home.vue'
import Dashboard from '../views/Dashboard.vue'
import DashboardEvent from '../views/DashboardEvent.vue'
import DashboardSPM from '../views/DashboardSPM.vue'
import DashboardCSI from '../views/DashboardCSI.vue'
import DashboardDetailSPM from '../views/DashboardDetailSPM.vue'
import DashboardDetailCSI from '../views/DashboardDetailCSI.vue'
import Reset from '../views/resetpass.vue'
import LegalConfig from '../views/LegalConfig.vue'
import LegalEdit from '../views/LegalEdit.vue'
import AddLegal from '../views/legalAdd.vue'
import User from '../views/User.vue'
import UserEdit from '../views/UserEdit.vue'
import AddUser from '../views/UserAdd.vue'
import HighChart from '../views/highchart.vue'

import ProfilePage from '../views/LandingPage/Profil.vue'

import auth from './middleware/auth'
import VueAnalytics from 'vue-analytics'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../views/V2/Isupplier.vue'),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('../views/V2/Home.vue'),
      },
      {
        path: '/level1',
        component: () => import('../views/V2/Level1.vue'),
      },
      {
        path: '/user-role',
        component: () => import('../views/V2/UserRoleSetting.vue'),
      },
      {
        path: '/user-role/edit/:id',
        component: () => import('../views/UserEdit.vue'),
      },
      {
        path: '/user-role/add',
        component: () => import('../views/UserAdd.vue'),
      },
      {
        path: '/notifications',
        component: () => import('../views/Notification/index.vue'),
        children: [
          {
            path: '/',
            component: () => import('../views/Notification/notif.vue'),
          },
        ],
      },
      {
        path: '/document-notif',
        component: () => import('../views/DocumentNotif/index.vue'),
        children: [
          {
            path: '/',
            component: () => import('../views/DocumentNotif/notif.vue'),
          },
        ],
      },
      {
        path: '/myrequest',
        component: () => import('../views/MyRequest/index.vue'),
        children: [
          {
            path: '/',
            component: () => import('../views/MyRequest/requestList.vue'),
          },
          {
            path: '/myrequest/new/:type',
            component: () => import('../views/MyRequest/myRequest.vue'),
          },
          {
            path: '/myrequest/detail/:id',
            component: () => import('@/views/MyRequest/requestDetail.vue'),
          },
          {
            path: '/myrequest/update-vendor/:id',
            component: () => import('@/views/Approval/vendorUpdate.vue'),
          },
          {
            path: '/myrequest/review/extend-to-sap/:id',
            component: () => import('@/views/Approval/reviewExtend.vue'),
          },
          {
            path: '/myrequest/review/block-vendor/:id',
            component: () => import('@/views/Approval/reviewBlock.vue'),
          },
          {
            path: '/myrequest/review/unblock-vendor/:id',
            component: () => import('@/views/Approval/reviewUnblock.vue'),
          },
          {
            path: '/myrequest/validation/:id/:status',
            component: () => import('@/views/NewTab/Level2.vue'),
          },
          {
            path: '/myrequest/csi/:id/:type/:status/:userid',
            component: () => import('@/views/MyRequest/csiForm.vue'),
          },
          {
            path: '/myrequest/review/praqualifikasi-k3l/:id/:status/:type',
            component: () =>
              import('@/views/Approval/reviewPraqualifikasiK3L.vue'),
          },
          {
            path: '/myrequest/k3l-validation/:id/:status',
            component: () => import('@/views/Approval/ValidationK3L.vue'),
          },
        ],
      },
      {
        path: '/approval',
        component: () => import('../views/Approval/index.vue'),
        children: [
          {
            path: '/',
            component: () => import('../views/Approval/approvalList.vue'),
          },
          {
            path: '/approval/new',
            component: () => import('../views/Approval/myApproval.vue'),
          },
          {
            path: '/approval/detail/:id/:status',
            component: () => import('@/views/Approval/ApproveVendor.vue'),
          },
          {
            path: '/approval/detail/:id/:status/:type',
            component: () => import('@/views/Approval/ApproveVendor.vue'),
          },
          {
            path: '/approval/update-vendor/:id/:status',
            component: () => import('@/views/Approval/vendorUpdate.vue'),
          },
          {
            path: '/approval/review/extend-to-sap/:id/:status',
            component: () => import('@/views/Approval/reviewExtend.vue'),
          },
          {
            path: '/approval/review/block-vendor/:id/:status',
            component: () => import('@/views/Approval/reviewBlock.vue'),
          },
          {
            path: '/approval/review/unblock-vendor/:id/:status',
            component: () => import('@/views/Approval/reviewUnblock.vue'),
          },
          {
            path: '/approval/review/praqualifikasi-k3l/:id/:status/:type',
            component: () =>
              import('@/views/Approval/reviewPraqualifikasiK3L.vue'),
          },
          {
            path: '/approval/k3l-validation/:id/:status',
            component: () => import('@/views/Approval/ValidationK3L.vue'),
          },
          {
            path: '/approval/k3l-validation-oc/:id/:status',
            component: () => import('@/views/Approval/ValidationK3L-OC.vue'),
          },
          {
            path: '/approval/k3l-validation-hoc/:id/:status',
            component: () => import('@/views/Approval/ValidationK3L-HOC.vue'),
          },
          {
            path: '/approval/review/praqualifikasi-kplh/:id/:status/:type',
            component: () =>
              import('@/views/Approval/reviewPraqualifikasiK3L.vue'),
          },
          {
            path: '/approval/kplh-validation/:id/:status',
            component: () => import('@/views/Approval/ValidationKplh.vue'),
          },
          {
            path: '/approval/kplh-validation-hse/:id/:status',
            component: () => import('@/views/Approval/ValidationKplh.vue'),
          },
          {
            path: '/approval/kplh-validation-head/:id/:status',
            component: () => import('@/views/Approval/ValidationKplh.vue'),
          },
          {
            path: '/approval/kplh-validation-ktt/:id/:status',
            component: () => import('@/views/Approval/ValidationKplh.vue'),
          },
          {
            path: '/approval/kplh-validation-hse-ktt/:id/:status',
            component: () => import('@/views/Approval/ValidationKplh-HSE.vue'),
          },
          {
            path: '/approval/pra-legal/:id/:status/:type',
            component: () => import('@/views/Approval/ApproveVendor.vue'),
          },
        ],
      },
      {
        path: '/dashboard',
        component: () => import('@/views/Dashboard/index'),
      },
      {
        path: '/kpi',
        component: () => import('@/views/Dashboard/KPI/index'),
      },

      {
        path: '/dashboard-va',
        component: () => import('@/views/Dashboard/Vendor-Analytic/index'),
      },
      {
        path: '/monitoring',
        component: () => import('@/views/Dashboard/Monitoring/index'),
      },
      {
        path: '/mail-ssi',
        component: () => import('@/views/Dashboard/KPI/mailSsi.vue'),
      },
      {
        path: '/validation',
        component: () => import('@/views/NewTab/Level1.vue'),
        children: [
          {
            path: '/validation/:id/:status',
            component: () => import('@/views/NewTab/Level2.vue'),
          },
        ],
      },
      {
        path: '/level2',
        component: () => import('../views/V2/Level2.vue'),
      },
    ],
  },
  {
    path: '/review/sipm',
    component: () => import('../views/V2/Isupplier.vue'),
    children: [
      {
        path: '/review/sipm/:id',
        name: 'level1',
        component: () => import('../views/NewTab/Level1.vue'),
      },
    ],
  },
  {
    path: '/pdf/k3l-document/:id/:vendor',
    component: () => import('../views/PDF/DocumentK3L.vue'),
  },
  {
    path: '/pdf/kplh-document/:id/:vendor',
    component: () => import('../views/PDF/DocumentKPLH.vue'),
  },
  {
    path: '/pdf/pakta-integritas',
    component: () => import('../views/PDF/PaktaIntegritas.vue'),
  },
  {
    path: '/pdf/form-vendor-bu',
    component: () => import('../views/PDF/VendorBadanUsaha.vue'),
  },
  {
    path: '/pdf/form-vendor-perorangan',
    component: () => import('../views/PDF/VendorPerorangan.vue'),
  },
  {
    path: '/pdf/surat-pernyataan-non-pkp',
    component: () => import('../views/PDF/SuratPernyataanNonPKP.vue'),
  },
  {
    path: '/pdf/komitmen-keselamatan-tambang',
    component: () => import('../views/PDF/KomitmenKeselamatanTambang.vue'),
  },
  {
    path: '/review-landing-page/:session',
    component: () => import('../views/LandingPage/LandingPage.vue'),
  },
  {
    path: '/revise-now/:id/:user',
    component: () => import('../views/LandingPage/LandingPage.vue'),
  },
  {
    path: '/review-from-landing-page/:id/:user',
    component: () => import('../views/LandingPage/LandingPage.vue'),
  },
  {
    path: '/landingpage/:session',
    component: () => import('../views/LandingPage/LandingPage.vue'),
    children: [
      {
        path: '',
        component: () => import('../views/LandingPage/Instruction.vue'),
      },
      {
        path: 'profil',
        component: () => import('../views/LandingPage/Profil.vue'),
      },
      {
        path: 'profilbu',
        component: () => import('../views/LandingPage/ProfilBU.vue'),
      },
      {
        path: 'alamat',
        component: () => import('../views/LandingPage/Alamat.vue'),
      },
      // {
      //   path: 'alamatbu',
      //   component: () => import('../views/LandingPage/AlamatBU.vue')
      // },
      {
        path: 'bank',
        component: () => import('../views/LandingPage/Bank.vue'),
      },
      // {
      //   path: 'bankbu',
      //   component: () => import('../views/LandingPage/BankBU.vue')
      // },
      {
        path: 'afiliasi',
        component: () => import('../views/LandingPage/Afiliasi.vue'),
      },
      // {
      //   path: 'afiliasibu',
      //   component: () => import('../views/LandingPage/AfiliasiBU.vue')
      // },
      {
        path: 'legalitas',
        component: () => import('../views/LandingPage/Legalitas.vue'),
      },
      {
        path: 'legalitasbu',
        component: () => import('../views/LandingPage/LegalitasBU.vue'),
      },
      {
        path: 'selesai',
        component: () => import('../views/LandingPage/Selesai.vue'),
      },
    ],
  },
  {
    path: '/masterdata-database',
    component: () => import('@/views/MasterData/Index'),
  },
  {
    path: '/matrix-legal',
    component: () => import('@/views/MasterData/Matrix/index.vue'),
  },
  {
    path: '/md-landingpage',
    component: () => import('@/views/MasterData/LandingPage/LandingPage.vue'),
  },
  {
    path: '/:resetpass?',
    name: 'resetpass',
    component: Reset,
  },
]

const router = new VueRouter({
  routes,
})

Vue.use(VueAnalytics, {
  id: 'UA-115628282-10',
  router,
})

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    context.next(...parameters)
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]

    const context = {
      from,
      next,
      router,
      to,
    }
    const nextMiddleware = nextFactory(context, middleware, 1)

    return middleware[0]({ ...context, next: nextMiddleware })
  }

  return next()
})

export default router
